export const Logo = ({ light = false, className = "h-11" }) => (
  <img
    src={light ? "/brand/logo-light.webp" : "/brand/logo.png"}
    alt="District Gaslight"
    width="520"
    height="166"
    className={`w-auto ${className}`}
    data-testid="brand-logo"
  />
);
